export const COPIED_TOAST_TIME = 2750;
